module.exports = __webpack_public_path__ + "15046f3626b09744c659e1b515f5194e.svg";